import { render, staticRenderFns } from "./SurveysPage.vue?vue&type=template&id=526936a9"
import script from "./SurveysPage.vue?vue&type=script&lang=js"
export * from "./SurveysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports